<template>
  <UApp :locale="uiLocale">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <Modal ref="modal"></Modal>
  </UApp>
</template>

<script lang="ts" setup>
import { de, en, es, fr, it } from "@nuxt/ui/locale";

const config = useRuntimeConfig();
const nuxtApp = useNuxtApp();

// The page and Nuxt UI's own words (a close button, an empty list) in the person's language: screen readers
// pronounce the text with the language the page declares.
const { locale } = useI18n();
const UI_LOCALES = { de, en, es, fr, it };
const uiLocale = computed(() => UI_LOCALES[locale.value as keyof typeof UI_LOCALES] ?? fr);

const modal = ref(null);

useHead({
  htmlAttrs: { lang: () => locale.value },
  script: [
    { src: "/libraries/webfont.js" },
    {
      src: "https://app.ailo.pro/widget.js",
      "data-workspace": "0e5c7443-7879-4dcb-9d69-5178f2a4235e",
      async: true,
    },
  ],
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${ titleChunk } | ${ config.public.appName }` : "Printags";
  }
});

onMounted(() => {
  if (!nuxtApp.$swal) nuxtApp.provide("swal", modal.value);
});
</script>

<script lang="ts">

export default {
  name: "Index"
};

</script>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.3s;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
}
</style>
